import { fromJS } from 'immutable'
import {
  LEAVE_ENTITLEMENT_LIST_REQUEST,
  LEAVE_ENTITLEMENT_LIST_SUCCESS,
  LEAVE_ENTITLEMENT_LIST_FAILURE,
  LEAVE_ENTITLEMENT_LIST_RESET,
} from './../../constants'

const init = fromJS({
  isFetching: false,
  isAuthenticated: localStorage.getItem('access_token') !== null,
  redirect: false,
})

export default (state = init, action) => {
  switch (action.type) {
    case LEAVE_ENTITLEMENT_LIST_REQUEST:
      return state
        .set('isFetching', true)
    case LEAVE_ENTITLEMENT_LIST_SUCCESS:
      return state
        .set('leaveEntitlements', fromJS(action.payload.leaveEntitlements))
        .set('isFetching', false)
    case LEAVE_ENTITLEMENT_LIST_FAILURE:
      if (action.payload.status === 401) {
        return state
          .set('redirect', true)
      }
      return state
        .set('isFetching', false)
    case LEAVE_ENTITLEMENT_LIST_RESET:
      return state
        .delete('leaveEntitlements')
        .set('isFetching', false)
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/leave-entitlement/leave-entitlement-list-reducer.js